



























































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { EventBus } from "../event-bus";
import ConfirmationModal from "./ConfirmationModal.vue";
import DeleteModal from "./DeleteModal.vue";
import DiscardModal from "./DiscardModal.vue";

@Component({
  components: {
    ConfirmationModal,
    DeleteModal,
    DiscardModal,
  },
})
export default class Details extends Vue {
  private status = true;
  private firstNameRules: any = [];
  private lastNameRules: any = [];
  private extensionRules: any = [];
  private descriptionRules: any = [];
  private emailRules:any=[];
  private locationRules:any=[];

  private ipv4Rules:any =[];

  private confirmationModalFlag = false;
  private deleteModalFlag = false;
  private discardModalFlag = false;

  private isSaveEnabled = true;

  private changesMade = false;

  private errorModalFlag = false;
  private errorText = "";
  private errorTitle = "";

  @Prop() user!: any;

  created() {
    EventBus.$off('closeErrorModal')
    EventBus.$off('closeConfirmationModal')
    EventBus.$off('closeDeleteModal')
    EventBus.$off('closeDiscardModal')


    this.status = this.user["accountStatus"] == 100 ? true : false;
    EventBus.$on("closeConfirmationModal", (value: boolean) => {
      this.confirmationModalFlag = value;
    });

    EventBus.$on("closeDeleteModal", (value: boolean) => {
      this.deleteModalFlag = value;
    });

    EventBus.$on("closeDiscardModal", (value: boolean) => {
      this.discardModalFlag = value;
    });

    EventBus.$on("closeErrorModal", (value: boolean) => {
      this.errorModalFlag = value;
    });
  }

  @Watch("user.accountStatus")
  disabledSwitchChanged() {
    this.changesMade = true;
    this.isSaveEnabled = false;
    this.status = !this.status;
    EventBus.$emit("triggerDiscardModal", true);
  }

  @Watch("user.firstName")
  firstNameChanged() {
    this.firstNameRules = [];
    this.changesMade = true;
    this.isSaveEnabled = false;
    EventBus.$emit("triggerDiscardModal", true);
  }

  @Watch("user.lastName")
  lastNameChanged() {
    this.lastNameRules = [];
    this.changesMade = true;
    this.isSaveEnabled = false;
    EventBus.$emit("triggerDiscardModal", true);
  }

  @Watch("user.email")
  emailChanged() {
    this.emailRules = [];
    this.changesMade = true;
    this.isSaveEnabled = false;
    EventBus.$emit("triggerDiscardModal", true);
   }

  @Watch("user.location")
  locatinoChanged() {
    this.locationRules = [];
    this.changesMade = true;
    this.isSaveEnabled = false;
    EventBus.$emit("triggerDiscardModal", true);
   }

  @Watch("user.extension")
  extensionChanged() {
    this.extensionRules = [];
    this.changesMade = true;
    this.isSaveEnabled = false;
    EventBus.$emit("triggerDiscardModal", true);
  }

  @Watch("user.description")
  descriptionChanged() {
    this.descriptionRules = [];
    this.changesMade = true;
    this.isSaveEnabled = false;
    EventBus.$emit("triggerDiscardModal", true);
  }

  

  private submitHandler(): void {
    this.firstNameRules = [
      (v: any) => !!v || "First Name is required",
      (v: any) =>
        /^[a-zA-Z]+$/.test(v) || "First Name must contain only letters",
      (v: any) =>
        /^.{1,65536}$/.test(v) || "First Name max length is 65536 characters",
    ];

    this.lastNameRules = [
      (v: any) => !!v || "Last Name is required",
      (v: any) =>
        /^[a-zA-Z]+$/.test(v) || "Last Name must contain only letters",
      (v: any) =>
        /^.{1,65536}$/.test(v) || "Last Name max length is 65536 characters",
    ];

    this.extensionRules = [
      (v: any) => !!v || "Extension is required",
      (v: any) =>
        /^\d{3,5}$/.test(v) || "Extension must be between 3 and 5 digits",
    ];

    this.emailRules=[
      (v: any) => !!v || "Email is required",
      (v: any) =>
        /^\w+([.-_]\w+)*@\w+([.-_]\w+)*(\.[a-zA-Z]{2,3})+$/.test(v) || "invalid email",
    ];
    //accepted:
    //aaa9.9-k_o@y8.comp.edu.com    ang.sfyr@gmail.com    ang_sftr@yahoo.gr   tei@uniwa.edu.gr    teia.l@unima.gpr

    this.locationRules=[
      (v: any) => !!v || "Location is required",
      (v: any) =>
        /^[\w ]+(?:[,.-][\w ]+)*[,.-]?$/.test(v) || "Location must contain letters numbers -., ",
    ];

    this.descriptionRules = [
      (v: any) =>
        /^.{0,65536}$/.test(v) || "Description max length is 65536 characters",
    ];

   this.ipv4Rules = [
      (v: any) => !!v || "Is required",
      (v: any) =>
        /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(v) || "Must be of the form xxx.xxx.xxx.xxx or x.x.x.x",
    ];

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    setTimeout(function () {
      // In order for TypeScript to know which type is being used for form, we need to cast the value.
      const result = (
        self.$refs.form as Vue & {
          validate: () => boolean;
        }
      ).validate();
      console.log("result of validation:", result);
      if (result) {
        // successful validation -> open confirmation modal
        self.confirmationModalFlag = true;
      } 
    });
  }

  private cancel(): void {
    if (this.changesMade) {
      //show discard modal
      this.discardModalFlag = true;
    } else {
      EventBus.$emit("closeEditAccountModal", false);
      EventBus.$emit("closeEditDeviceModal", false);
    }
  }

  private showDeleteModal(): void {
    this.deleteModalFlag = true;
  }
}
